import { GTMProvider } from "@elgorditosalsero/react-gtm-hook";
import { TooltipProvider } from "@gigpro/ui/Tooltip";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { ToastMessage } from "components/ToastMessage";
import { env } from "config/env";
import { LaunchDarklyProvider } from "providers/LaunchDarkly";
import { ThemeProvider } from "providers/Theme";
import React from "react";
import { Outlet } from "react-router";

export const RootProvider = React.memo(() => (
  <GTMProvider
    state={{
      id: env.REACT_APP_GTM_ID,
      environment: { gtm_auth: env.REACT_APP_GTM_AUTH, gtm_preview: env.REACT_APP_GTM_ENV },
      injectScript: import.meta.env.PROD,
    }}
  >
    <LaunchDarklyProvider>
      <ReactQueryDevtools initialIsOpen={false} position="bottom-right" />
      <ThemeProvider>
        <TooltipProvider delayDuration={300}>
          <ToastMessage />
          <Outlet />
        </TooltipProvider>
      </ThemeProvider>
    </LaunchDarklyProvider>
  </GTMProvider>
));
